import { Button } from "@mui/material";
import React, { useContext, useState } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ToggleContext from "../_helper/Customizer";

const ReturnMenu = ({ children }) => {
  const { toggleIcon, toggleSidebar } = useContext(ToggleContext);
//   const [toggle, setToggle] = useState(!toggleIcon);

  const openCloseSidebar = () => {
    // setToggle((prevState) => !prevState);
    toggleSidebar(!toggleIcon);
  };
  console.log(useContext(ToggleContext), "CheckContext");
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
      {/* {toggleIcon && (
        <div style={{ maxWidth: "fit-content" }}>
          <Button
            startIcon={<ArrowBackIcon />}
            onClick={openCloseSidebar}
            variant="contained"
            color="primary"
            style={{
              minWidth: "auto",
              whiteSpace: "nowrap",
              padding: "6px 16px",
            }}
          >
            Back to Menu
          </Button>
        </div>
      )} */}

      {children}
    </div>
  );
};

export default ReturnMenu;
